import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { CompaniesService } from '../services/companies.service';

let cached: boolean | null = null;

export const companyOwnerGuard = (async (
  _route?: Route,
  _segments?: UrlSegment[]
): Promise<boolean | UrlTree> => {
  if (cached === true) return true;
  const companies = inject(CompaniesService);
  const router = inject(Router);
  try {
    const mine = await firstValueFrom(companies.list('mine'));
    if (mine.length > 0) { cached = true; return true; }
  } catch {
    // fall through to redirect
  }
  return router.parseUrl('/');
}) satisfies CanMatchFn;

/** Test-only: resets the in-memory cache between specs. */
export function __resetCompanyOwnerGuardCache(): void { cached = null; }
